import { Alchemy, Network } from "alchemy-sdk";
import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import env from "../environments/config";

const settings = {
  apiKey: env.ACCOUNT_KIT_API_KEY, 
  network: Network.ETH_SEPOLIA,
};

export const web3 = createAlchemyWeb3(env.ALCHEMY_KEY); 
export const alchemy = new Alchemy(settings);
